import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Scrollbars } from "react-custom-scrollbars";


const styleShadowBase = {
  position: "absolute",
  left: 0,
  right: 0,
  height: 40,
  marginRight: "5%",
  pointerEvents: "none"
};

const estiloView = {
  position: "absolute",
  top: "0px",
  left: "0px",
  right: "0px",
  bottom: "0px",
  overflowY: "scroll",
  overflowX: "hidden",
  marginBottom: "0px",
  marginRight: "-17px",
  paddingRight: "10px",
};

const estiloContainerSemScrollHorizontal = {
	width: "100%", 
	overflow: "hidden"
};

const ScrollBarGradiente = (props) => {
  const { 
    estilo,
    distanciaScrollTopo,
    exibirGradiente,
    larguraGradiente,
    corGradiente,
    autoRolagem,
    onScrollEnableChange,
		habilitarScrollHorizontal
  } = props;

  const deveExibirGradiente = exibirGradiente !== false;
  const scrollRef = useRef(null);
  const valoresAterioresScroll = useRef(null);
 
  const [styleShadowTop, setStyleShadowTop] = useState({
    ...styleShadowBase,
    top: 0,
    width: deveExibirGradiente ? larguraGradiente || "100%" : "0",
    background: corGradiente
  });

  const [styleShadowBottom, setStyleShadowBottom] = useState({
    ...styleShadowBase,
    bottom: 0,
    width: deveExibirGradiente ? larguraGradiente || "100%" : "0",
    background: corGradiente
  });

  const calcularScrollBottom = (valores) => {
    if (!valores) return 0;
    return valores.scrollHeight - valores.clientHeight - valores.scrollTop;
  };

  const possuiScroll = (valores) => {
    return valores && valores.scrollHeight > valores.clientHeight 
      ? true : false;
  };
  
  const aplicarAutoRolagem  = (valores) => {
    if (!autoRolagem) return;

    const scrollTop = valores.scrollTop;
    let efetuouRolagem = false;

    if (possuiScroll(valores)) { 
      const scrollBottom = calcularScrollBottom(valoresAterioresScroll.current);
      const distanciaMaxima = autoRolagem.hasOwnProperty("distanciaMaximaAtiva")
        ? autoRolagem.distanciaMaximaAtiva : 10000000;
      
      if (autoRolagem.direcao === "baixo" && scrollBottom <= distanciaMaxima)  {

        scrollRef.current.scrollToBottom();
        efetuouRolagem = true;
        
      } else if (autoRolagem.direcao === "cima" && scrollTop <= distanciaMaxima) {
        
        scrollRef.current.scrollToTop();
        efetuouRolagem = true;
      }
    }

    if (autoRolagem.callback)
      autoRolagem.callback(efetuouRolagem);
  };

  const haAlgumValorAlterado = (agora, antes) => {
    return (
      !agora || !antes ||
      agora.clientHeight !== antes.clientHeight ||
      agora.clientWidth !== antes.clientWidth ||
      agora.left !== antes.left ||
      agora.scrollHeight !== antes.scrollHeight ||
      agora.scrollLeft !== antes.scrollLeft ||
      agora.scrollTop !== antes.scrollTop ||
      agora.scrollWidth !== antes.scrollWidth ||
      agora.top !== antes.top
    ) ? true : false;
  };

  const atualizarExibicaoGradientes = (valores) => {
    const { scrollTop, scrollHeight, clientHeight } = valores;
    const shadowTopOpacity = (1 / 20) * Math.min(scrollTop, 20);
    const bottomScrollTop = scrollHeight - clientHeight;
    const shadowBottomOpacity =
      (1 / 20) * (bottomScrollTop - Math.max(scrollTop, bottomScrollTop - 20));

    let displayTop = "";
    let displayBottom = "";

    displayTop = shadowTopOpacity === 0 ? "none" : "block";
    displayBottom = shadowBottomOpacity === 0 ? "none" : "block";

    if (styleShadowTop.display !== displayTop || 
      styleShadowTop.opacity !== shadowTopOpacity) {
        
      setStyleShadowTop({
        ...styleShadowTop,
        display: displayTop,
        opacity: shadowTopOpacity,
      });
    }

    if (styleShadowBottom.display !== displayBottom || 
      styleShadowBottom.opacity !== shadowBottomOpacity) {
      
      setStyleShadowBottom({
        ...styleShadowBottom,
        display: displayBottom,
        opacity: shadowBottomOpacity,
      });
    }
  };

  const handleUpdate = (valores) => {
    const valoresAntes = valoresAterioresScroll.current;

    if (!haAlgumValorAlterado(valores, valoresAntes))
      return;

    if (deveExibirGradiente)
      atualizarExibicaoGradientes(valores);

    const alturaAnterior = valoresAntes && valoresAntes.scrollHeight;

    if (valores.scrollHeight > alturaAnterior)
      aplicarAutoRolagem(valores);

    if (onScrollEnableChange) {
      const possuiScrollAgora = possuiScroll(valores);
      const possuiaScrollAntes = possuiScroll(valoresAntes);

      if (possuiScrollAgora !== possuiaScrollAntes)
        onScrollEnableChange(possuiScrollAgora);
    }

    valoresAterioresScroll.current = valores;
  };

  const pixelsScrollTopo = distanciaScrollTopo;

  const containerStyle = {
    height: "100%",
    ...estilo,
    position: "relative",
    marginRight: "-10px",
  };

  const onScrollStop = () => {
    const valores = { ...scrollRef.current.getValues() }
    valores.scrollBottom = calcularScrollBottom(valores);
    props.onScrollStop(valores);
  };  

  return (
    <div className="default-scroll" style={containerStyle}>
      <Scrollbars
        ref={scrollRef}
        onUpdate={handleUpdate}
        onScrollStop={props.onScrollStop && onScrollStop}
        renderView={({ style }) => <div style={{ ...style, ...estiloView }} />}
        renderTrackVertical={({ style }) => (
          <div
            style={{
              ...style,
              right: "0px",
              borderRadius: "4px",
              width: "6px",
              top: pixelsScrollTopo,
              bottom: "2px",
            }}
          />
        )}
      >
				{habilitarScrollHorizontal === false 
					? <div style={estiloContainerSemScrollHorizontal}>{props.children}</div>
					: props.children 
				}
      </Scrollbars>

      <div style={styleShadowTop} />

      <div style={styleShadowBottom} />
    </div>
  );
};


ScrollBarGradiente.propTypes = {
  /** Propriedade para estilizar o componente através de classes */
  estilo: PropTypes.object,
  /** Propriedade para definir a largura do gradiente */
  larguraGradiente: PropTypes.string,
  /** Define a distancia do scroll do topo */
  distanciaScrollTopo: PropTypes.string,
  /** Define a cor do gradiente */
  corGradiente: PropTypes.string,
  /** Define se o gradiente deve ou não ser exibido */
  exibirGradiente: PropTypes.bool,
	/** Define se deve possibilitar scroll horizontal */
  habilitarScrollHorizontal: PropTypes.bool,
};

ScrollBarGradiente.defaultProps = {
  estilo: {
    width: "100%",
    height: "100%",
  },
  larguraGradiente: "100%",
  distanciaScrollTopo: "2px",
  corGradiente:
    "linear-gradient(to bottom, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0) 100%)"
};

export default ScrollBarGradiente;
